import * as React from "react";
const SvgFirstPageOutlined = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path fill="none" d="M24 0v24H0V0h24z" opacity={0.87} />
    <path d="M18.41 16.59 13.82 12l4.59-4.59L17 6l-6 6 6 6 1.41-1.41zM6 6h2v12H6V6z" />
  </svg>
);
export default SvgFirstPageOutlined;
